"use strict";
// record for puzzle
Object.defineProperty(exports, "__esModule", { value: true });
exports.PuzzleRecordHelper = void 0;
// Helper class for puzzle records
class PuzzleRecordHelper {
    /**
     * Convert internal interface to JSON
     *
     * @param i
     * @constructor
     */
    static IToJ(i) {
        return i;
    }
    /**
     * Convert JSON to internal interface
     * @param j
     * @constructor
     */
    static JToI(j) {
        return j;
    }
    /**
     * Convert array of internal interface to array of JSON
     * @param is
     * @constructor
     */
    static IToJArray(is) {
        // if null, return it
        if (is == null) {
            return is;
        }
        let js = [];
        for (let i = 0; i < is.length; i++) {
            js.push(PuzzleRecordHelper.IToJ(is[i]));
        }
        return js;
    }
    /**
     * Convert array of JSON to array of internal interface
     * @param js
     * @constructor
     */
    static JToIArray(js) {
        // if null, return it
        if (js == null) {
            return js;
        }
        let is = [];
        for (let i = 0; i < js.length; i++) {
            is.push(PuzzleRecordHelper.JToI(js[i]));
        }
        return is;
    }
}
exports.PuzzleRecordHelper = PuzzleRecordHelper;
//# sourceMappingURL=PuzzleRecord.js.map